import { render, staticRenderFns } from "./TaskStandard.vue?vue&type=template&id=8927f2fa&scoped=true&"
import script from "./TaskStandard.vue?vue&type=script&lang=js&"
export * from "./TaskStandard.vue?vue&type=script&lang=js&"
import style0 from "./TaskStandard.vue?vue&type=style&index=0&id=8927f2fa&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8927f2fa",
  null
  
)

export default component.exports